var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-explorer-page" },
    [
      _c(
        "div",
        { staticClass: "explorer-container" },
        [
          _c("file-explorer-component", {
            ref: "fileExplorer",
            attrs: { title: "SECURAMDATA - Drive" },
            on: {
              "item-selected": _vm.handleItemSelected,
              "file-open": _vm.handleFileOpen,
              "delete-item": _vm.deleteItemFromContext,
              "download-file": _vm.downloadFile,
              "download-directory": _vm.handleDirectoryDownload,
              "show-upload-dialog": function($event) {
                _vm.showUploadDialog = true
              },
              "show-new-folder-dialog": function($event) {
                _vm.showNewFolderDialog = true
                _vm.focusNewFolderInput()
              },
              "show-item-details": _vm.handleShowItemDetails,
              "item-renamed": _vm.handleItemRenamed,
              "share-request": _vm.handleShareRequest,
              "show-sharing-info": _vm.handleShowSharingInfo
            }
          })
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "file-explorer-popup",
          attrs: { title: "Upload de Arquivo", active: _vm.showUploadDialog },
          on: {
            "update:active": function($event) {
              _vm.showUploadDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "upload-dialog-content" }, [
            _c(
              "div",
              {
                staticClass: "upload-area",
                on: {
                  click: _vm.triggerFileInput,
                  dragover: function($event) {
                    $event.preventDefault()
                  },
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.handleFileDrop($event)
                  }
                }
              },
              [
                _c("feather-icon", {
                  attrs: { icon: "UploadCloudIcon", size: "40" }
                }),
                _c("p", [
                  _vm._v("Arraste arquivos aqui ou clique para selecionar")
                ]),
                _c("input", {
                  ref: "fileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", multiple: "" },
                  on: { change: _vm.handleFileInputChange }
                })
              ],
              1
            ),
            _vm.selectedFiles.length > 0
              ? _c(
                  "div",
                  { staticClass: "selected-files-list" },
                  [
                    _vm._l(_vm.selectedFiles, function(file, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "selected-file" },
                        [
                          _c("span", [_vm._v(_vm._s(file.name))]),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-danger", size: "sm" },
                              on: {
                                click: function($event) {
                                  return _vm.removeFile(index)
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "XIcon", size: "16" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _c("div", { staticClass: "selected-files-count" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedFiles.length) +
                          " arquivo(s) selecionado(s) "
                      )
                    ])
                  ],
                  2
                )
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "footer-dialog" },
            [
              _c(
                "b-button",
                {
                  class: { "b-button-loading": _vm.uploading },
                  attrs: {
                    variant: "primary",
                    disabled: !_vm.selectedFiles.length
                  },
                  on: { click: _vm.uploadFiles }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "UploadIcon", size: "16" }
                  }),
                  _vm._v(" Upload ")
                ],
                1
              ),
              _c(
                "b-button",
                {
                  staticClass: "ml-2",
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function($event) {
                      _vm.showUploadDialog = false
                    }
                  }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "XIcon", size: "16" }
                  }),
                  _vm._v(" Cancelar ")
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "vs-popup",
        {
          staticClass: "file-explorer-popup",
          attrs: { title: "Nova Pasta", active: _vm.showNewFolderDialog },
          on: {
            "update:active": function($event) {
              _vm.showNewFolderDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "new-folder-content" }, [
            _c(
              "div",
              { staticClass: "mb-3" },
              [
                _c("label", { attrs: { for: "folderName" } }, [
                  _vm._v("Nome da Pasta")
                ]),
                _c("b-form-input", {
                  ref: "newFolderNameInput",
                  staticClass: "w-100",
                  attrs: {
                    id: "folderName",
                    placeholder: "Digite o nome da pasta"
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.createFolder($event)
                    }
                  },
                  model: {
                    value: _vm.newFolderName,
                    callback: function($$v) {
                      _vm.newFolderName = $$v
                    },
                    expression: "newFolderName"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "footer-dialog" },
            [
              _c(
                "b-button",
                {
                  class: { "b-button-loading": _vm.creatingFolder },
                  attrs: { variant: "primary", disabled: !_vm.newFolderName },
                  on: { click: _vm.createFolder }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "FolderPlusIcon", size: "16" }
                  }),
                  _vm._v(" Criar ")
                ],
                1
              ),
              _c(
                "b-button",
                {
                  staticClass: "ml-2",
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function($event) {
                      _vm.showNewFolderDialog = false
                    }
                  }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "XIcon", size: "16" }
                  }),
                  _vm._v(" Cancelar ")
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("file-details-popup", {
        attrs: { item: _vm.selectedItem },
        scopedSlots: _vm._u([
          {
            key: "footer-actions",
            fn: function() {
              return [
                _vm.selectedItem &&
                _vm.selectedItem.type === "file" &&
                _vm.selectedItem.is_owner
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "drive.delete_file",
                            expression: "'drive.delete_file'"
                          }
                        ],
                        class: { "b-button-loading": _vm.deleting },
                        attrs: { variant: "danger" },
                        on: { click: _vm.confirmDeleteItemInPopup }
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "Trash2Icon", size: "16" }
                        }),
                        _vm._v(" Excluir ")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedItem &&
                _vm.selectedItem.type === "directory" &&
                _vm.selectedItem.is_owner
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "drive.delete_directory",
                            expression: "'drive.delete_directory'"
                          }
                        ],
                        class: { "b-button-loading": _vm.deleting },
                        attrs: { variant: "danger" },
                        on: { click: _vm.confirmDeleteItemInPopup }
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "Trash2Icon", size: "16" }
                        }),
                        _vm._v(" Excluir ")
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.showItemDetails,
          callback: function($$v) {
            _vm.showItemDetails = $$v
          },
          expression: "showItemDetails"
        }
      }),
      _c("share-resource-popup", {
        attrs: {
          resource: _vm.shareResource,
          fileExplorerService: _vm.fileExplorerService
        },
        on: { shared: _vm.handleResourceShared },
        model: {
          value: _vm.showShareResourcePopup,
          callback: function($$v) {
            _vm.showShareResourcePopup = $$v
          },
          expression: "showShareResourcePopup"
        }
      }),
      _c("sharing-details-popup", {
        attrs: { item: _vm.sharingDetailsItem },
        model: {
          value: _vm.showSharingDetails,
          callback: function($$v) {
            _vm.showSharingDetails = $$v
          },
          expression: "showSharingDetails"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }